import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IDomainsPortfolioEntityState} from "../reducers/domains-portfolio.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getDomainsPortfolioState = () =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.domainsPortfolio.domains_portfolio);

export const getPurchasedDomains = () => createSelector(getDomainsPortfolioState(),
  (state: IDomainsPortfolioEntityState) => state.purchased_domains
);

